// extracted by mini-css-extract-plugin
export default {"BottomRow":"style_BottomRow__4ak9j"};